module.exports = __webpack_public_path__ + "media/images/countrysquared/bf-ddfe0f101ff6ebdd945b975d29c29269.svg";